//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import { CreatorsCampaignsTrackingIds } from '@campaigns/components/campaign-requests/creator-campaigns/CreatorsCampaignsTrackingId';
import { DeleteContentModal } from '@creator-community/components/DeleteContentModal';
import makeAngularReactControllerWithScope from '@react-bridge/angular-react-widget-with-scope';

import { ISelectedItem } from 'app/bulk-actions/model/ISelectedItem';

interface UiaDeleteContentModalProps {
  campaignSlugName: string;
  isOpen: boolean;
  onClose: () => void;
  selectedItems: ISelectedItem[];
}

export const UiaDeleteContentModal = ({
  campaignSlugName,
  isOpen,
  onClose,
  selectedItems,
}: UiaDeleteContentModalProps) => {
  // Extract content IDs from selected items
  const contentIds = selectedItems.map((item) => item.cuid);

  const handleCloseModal = () => {
    onClose();
  };

  return (
    <DeleteContentModal
      campaignSlugName={campaignSlugName}
      closeModal={handleCloseModal}
      contentIds={contentIds}
      isOpen={isOpen}
      trackingId={CreatorsCampaignsTrackingIds.DELETE_CONTENT_BUTTON}
    />
  );
};

angular.module('curalate').component('uiaDeleteContentModal', {
  bindings: {
    campaignSlugName: '@',
    isOpen: '<',
    onClose: '&',
    selectedItems: '<',
  },
  controller: makeAngularReactControllerWithScope(
    ({ $ctrl }: { $ctrl: UiaDeleteContentModalProps }) => {
      return <UiaDeleteContentModal {...$ctrl} />;
    },
  ),
});
